import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, filter, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IProfessionals } from '../../pages/professionals/list-professionals/list-professionals.component';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

interface IProfessionalsRequest {
  professionals: any[]
}

@Injectable({
  providedIn: 'root',
})
export class ProfessionalService {
    private professionalsSubject = new BehaviorSubject<any>(null as any)
    public professionals$ = this.professionalsSubject.asObservable();

  constructor(private http: HttpClient) {}

  register(data: any) {
    return this.http
      .post(environment.apiUrl + 'admin/professionals', data, httpOptions)
      .pipe(map((result) => result), catchError((error) => error));
  }

  getAllProfessionals() {
    this.http.get<any>(environment.apiUrl + `admin/professionals?page=1&limit=50`).subscribe((result: any) => {
      this.professionalsSubject.next(result.professionals as IProfessionals[]);
    });
  }

  getAll(status?: string, page: number = 1, limit: number = 10, search?: string, isActive?: boolean, employmentType?: string) {
    const params: string[] = [`page=${page}`, `limit=${limit}`];
    if (status) params.push(`status=${status}`);
    if (search) params.push(`search=${encodeURIComponent(search)}`);
    if (isActive !== undefined) params.push(`isActive=${isActive}`);
    if (employmentType) params.push(`employmentType=${employmentType}`);
    return this.http
      .get(environment.apiUrl + `admin/professionals?${params.join('&')}`, httpOptions)
      .pipe(map((result) => result), catchError((error) => error));
  }

  getAllWithContracts() {
    return this.http
      .get(environment.apiUrl + `professionals/contracts`, httpOptions)
      .pipe(map((result) => result), catchError((error) => error));
  }

  getDashboardSummary() {
    return this.http
      .get(environment.apiUrl + `admin/professionals/dashboard/summary`, httpOptions)
      .pipe(map((result) => result), catchError((error) => error));
  }

  getScales(startDate: string, endDate: string, id: string) {
    return this.http
      .get(environment.apiUrl + `admin/professionals/${id}/scales?startDate=${startDate}&endDate=${endDate}`, httpOptions)
      .pipe(map((result) => result), catchError((error) => error));
  }

  getById(id: string) {
    return this.http
      .get(environment.apiUrl + `admin/professionals/${id}`, httpOptions)
      .pipe(map((result) => result), catchError((error) => error));
  }

  getHistoriesById(id: string) {
    return this.http
      .get(environment.apiUrl + `admin/professionals/${id}/histories`, httpOptions)
      .pipe(map((result) => result), catchError((error) => error));
  }

  registerFormById(id: string) {
    return this.http
      .get(environment.apiUrl + `admin/professionals/${id}/generate/form`, { responseType: 'blob' })
      .pipe(map((result: Blob) => result));
  }

  updateById(id: string, data: any) {
    return this.http
      .put(environment.apiUrl + `admin/professionals/${id}`, data)
      .pipe(map((result) => result));
  }

  updatePasswordById(id: string, password: string) {
    return this.http
      .patch(environment.apiUrl + `admin/users/professionals/${id}/password`, { password })
      .pipe(map((result) => result), catchError((error) => error));
  }

  deleteById(id: string) {
    return this.http
      .delete(environment.apiUrl + `admin/professionals/${id}`, httpOptions)
      .pipe(map((result) => result));
  }

  status(professionalId: string, status: string) {
    return this.http
      .patch(environment.apiUrl + `admin/professionals/${professionalId}/status`, { status })
      .pipe(map((result) => result));
  }

  toggleActive(professionalId: string, isActive: boolean) {
    return this.http
      .patch(environment.apiUrl + `admin/professionals/${professionalId}/active`, { isActive })
      .pipe(map((result) => result));
  }
}
